// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import Weblogger, { type WeblogInitParams } from '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/@ks/weblogger/lib/log.browser';
  import AutoPV, { type AutoPVFilter } from '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/node_modules/@ks/weblogger/lib/plugins/autopv';
  import { ApplyPluginsType } from '@kmi/kmijs';
  import { getPluginManager } from '@@/core/plugin';
  
  let weblogger: Weblogger;
  
  export type { WeblogInitParams, AutoPVFilter };
  
  export function getWeblog(){
    if (weblogger) return weblogger;
  
    const monitorConfig = getPluginManager().applyPlugins({
      key: 'monitorConfig',
      type: ApplyPluginsType.modify,
      initialValue: {},
    });
  
    const filterHandler = monitorConfig.autoPVFilter;
  
    const logConfig = monitorConfig?.weblogger?.logConfig || {};
    const baseConfig = monitorConfig?.weblogger?.baseConfig || {}
  
    weblogger = new Weblogger({
      env: 'production',
      plugins: [
        new AutoPV({
          autoPVFilter(currentUrl, prevUrl, type) {
            if (filterHandler) {
              return filterHandler(currentUrl, prevUrl, type)
            } else {
              return true; // true 表示上报
            }
          },
        })
      ],
      ...logConfig,
    },
    {
      product_name: 'wanxiang_dmp',
      ...baseConfig,
    });
    return weblogger;
  }
  
  export {
    weblogger
  }